import { render, staticRenderFns } from "./StudioAudio.vue?vue&type=template&id=8b35ac12&"
import script from "./StudioAudio.vue?vue&type=script&lang=js&"
export * from "./StudioAudio.vue?vue&type=script&lang=js&"
import style0 from "./StudioAudio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports